import { toArray, uniq } from '@fxts/core';
import { Title } from '@services/MarppleShop/renderApp/components/atoms/Title/Title.ts';
import { SeeMoreLinkView } from '@services/MarppleShop/renderApp/components/cells/SectionTitle/views/SeeMoreLinkView/SeeMoreLinkView.ts';
import { FanLetterItemController } from '../../../../../../services/MarppleShop/renderApp/components/cells/FanLetterItem/controller/FanLetterItemController.ts';
import { FanLetterItemView } from '../../../../../../services/MarppleShop/renderApp/components/cells/FanLetterItem/FanLetterItemView.ts';
import { FanLetterFormController } from '../../../../../../services/MarppleShop/renderApp/components/cells/FanLetterList/controller/FanLetterFormController.ts';
import { FanLetterListView } from '../../../../../../services/MarppleShop/renderApp/components/cells/FanLetterList/FanLetterListView.ts';
import { ArrowView } from '../../../../../../services/MarppleShop/renderApp/components/cells/SectionTitle/views/ArrowView/ArrowView.ts';
import {
  hydrateRuneAndGetView,
  hydrateRuneAndGetViews,
} from '../../../../../../services/MarppleShop/shared/client/utils.ts';
import { MShopUtilF } from '../../../../Util/F/Function/module/MShopUtilF.js';
import { $find, $qs, $setCss } from 'fxdom/es';

/**
 * #### 스크롤시 sticky 컨테이너를 고정시키는 함수
 * @param isFixed {boolean} - true: 고정, false: 고정해제
 */
export const makePdFormToSticky = (isFixed) => {
  if (MShopUtilF.isMobile()) return;

  const sticky_container = $qs('.pd-form__sticky-slide-container');
  if (!sticky_container) return;

  const inner = $find('.inner-wrapper-sticky', sticky_container);
  if (!inner) return;

  const HEADER_HEIGHT = 80; // 스크롤시 ON/OFF 되는 헤더의 높이
  const topY = sticky_container.getBoundingClientRect().height - inner.getBoundingClientRect().height;
  const posY = Math.max(window.scrollY - HEADER_HEIGHT, 0);
  $setCss({ marginTop: isFixed ? `${Math.min(topY, posY)}px` : '' }, inner);
};

export const makeFanLetterScript = () => {
  /* 하이드레이션 및 이벤트 */
  const fan_letter_preview_container = $qs('.pd-contents__fan-letter-preview .swiper-container');
  if (fan_letter_preview_container) {
    hydrateRuneAndGetView(SeeMoreLinkView);
    hydrateRuneAndGetView(Title);

    const length = Number(fan_letter_preview_container.dataset.len);
    const is_swipe = MShopUtilF.isMobile() ? length > 1 : length > 4;
    if (is_swipe) {
      const swiper = new Swiper(fan_letter_preview_container, {
        slidesPerView: 'auto',
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        loop: true,
        grabCursor: true,
        navigation: {
          nextEl: `.pd-contents__fan-letter-preview-slide-btn .swiper-button-next`,
          prevEl: `.pd-contents__fan-letter-preview-slide-btn .swiper-button-prev`,
        },
      });
      if (!MShopUtilF.isMobile()) {
        hydrateRuneAndGetView(ArrowView)
          .addEventListener(ArrowView.LeftArrowClickEvent, () => {
            swiper.slidePrev();
          })
          .addEventListener(ArrowView.RightArrowClickEvent, () => {
            swiper.slideNext();
          });
      }
    }
  }
  /* swiper 다음에 해야한다 */
  const fan_letter_item_views = hydrateRuneAndGetViews(FanLetterItemView);
  const fan_letter_list_view = hydrateRuneAndGetView(FanLetterListView);
  new FanLetterItemController(
    toArray(uniq(fan_letter_item_views.concat(fan_letter_list_view.getFanLetterItemViews()))),
  );
  new FanLetterFormController(fan_letter_list_view.getFanLetterFormView());
};
